module.exports = "/packs/plus-white-e15fa13298d7fa21a10fd5cb246f5482.svg";